export const classes = {
  panel:
    'rounded-[20px] border border-black/10 bg-white/[0.82] p-0 shadow-aurora-card dark:border-white/10 dark:bg-[#332e43]/[0.84]',
  header: 'place-between px-[18px] pt-4',
  titleWrapper: 'flex items-center gap-2',
  title: 'text-sm font-bold leading-none text-taupe-3 dark:text-mauve-1',
  subtitle: 'text-xs font-medium text-taupe-2 dark:text-mauve-2',
  viewAll:
    'flex items-center gap-1 cursor-pointer select-none text-xs font-semibold text-brand-accent transition-colors dark:text-brand-accent-dark',
  viewAllIcon: 'size-3.5',
  tabs: 'px-[18px] pt-[9px]',
};
